module.exports = __webpack_public_path__ + "static/media/TwiggLogo.0e562a52.png";